import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

//const CHATBOT_ENDPOINT = import.meta.env.VITE_BACKEND_CHATBOT_SERVICE;

export interface FAQ {
  _id: string;
  faqId: string;
  category: 'customer' | 'provider' | 'general';
  question: string;
  answer: string;
  isEnabled: boolean;
  user?: string;
  createdAt: string;
  updatedAt: string;
}

export interface FAQResponse {
  success: boolean;
  faqs: FAQ[];
  count: number;
}

export interface FAQSearchResponse {
  success: boolean;
  faqs: FAQ[];
  count: number;
  query: string;
}

// export const getFaqs = async (
//   category: 'customer' | 'provider'
// ): Promise<FAQResponse> => {
//   try {
//     const response = await apiClient.get(
//       `/api/v1/faq/category?category=${category}`
//     );
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching FAQs:', error);
//     throw error;
//   }
// };

export const searchFaqs = async (
  category: 'customer' | 'provider',
  query: string
): Promise<FAQSearchResponse> => {
  try {
    const response = await apiClient.get(
      `${Path.faqSearch}?category=${category}&query=${encodeURIComponent(query)}`
    );
    return response.data;
  } catch (error) {
    console.error('Error searching FAQs:', error);
    throw error;
  }
};

export interface AIFAQSearchResponse {
  success: boolean;
  faqs: FAQ[];
  count: number;
  query: string;
  aiEnhanced: boolean;
  interpretedQuery?: {
    keywords: string[];
    categoryGuess: string | null;
    urgency: string;
  };
}

/**
 * AI-enhanced FAQ search. Calls hp-ai-service first to extract intent
 * keywords from natural language, then searches FAQs with enriched terms.
 * Fails soft to keyword search when AI is unavailable.
 */
export const aiSearchFaqs = async (
  category: 'customer' | 'provider',
  query: string
): Promise<AIFAQSearchResponse> => {
  try {
    const response = await apiClient.post(`${Path.faqAiSearch}`, {
      category,
      query,
    });
    return response.data;
  } catch (error) {
    console.error('Error in AI FAQ search:', error);
    throw error;
  }
};
